
import GoogleNavigateItem from "../googlenavigate/GoogleNavigateItem";
import GoogleReviewItem from "../googlereview/GoogleReviewItem";
import MainComment from "./MainComment";
import React, { useImperativeHandle, useRef } from "react";
import { AnalyticsEvent } from "../../analytics/AnalyticsEvent";
import { sendAction } from "../../utils/AnalyticsUtils";

const MapCurationListItem = React.forwardRef(({ placeItem, clickEvent, onNavigateClick, imageHeightClass, analytics }, ref) => {
    const itemRef = useRef(null)
    const description = placeItem.description
    useImperativeHandle(ref, () => ({
        // Expose any properties or functions you want to use externally
        getHeight: () => itemRef.current.clientHeight,
    }));

    const images = placeItem.images.slice(0,1).map((image) => {
        return <div className="carousel-item h-full w-full max-w-full">
            <img className="h-full w-full object-cover max-w-full" src={image.url} />
        </div>
    })
    return <div className="card bg-base-100 shadow-xl cursor-pointer rounded-md" ref={itemRef} onClick={() => {clickEvent(placeItem)}}>
    { images.length > 0 && <figure className="w-full">
        { 
            <div className={`carousel carousel-center w-full ${imageHeightClass}`}>{images}</div>
        }
    </figure>
    }
    <div className={`card-body ${images.length > 0 ? "w-full" : ""} p-4`}>
        <div className="">
            <div className="text-base-content text-lg font-bold text-base-content font-titan">{ placeItem.title }</div>
            {
                description && <div className="grow text-xs md:text-sm self-center text-base-content pt-2">
                    { description }
                </div>
            }
            {
                <div className="pt-2 flex justify-end">
                    <GoogleNavigateItem url={placeItem.googleMapUrl} isSmall={true} onClick={() => {onNavigateClick(placeItem.id)}} />
                </div>
            }
        </div>
    </div>
  </div>;

})

export default MapCurationListItem